export const RANGE_TYPE_LABELS = {
  CUSTOM: "cs",
  HOUR_1: "1h",
  HOUR_2: "2h",
  HOUR_12: "12h",
  HOUR_24: "24h",
  DAY_1: "1d",
  DAY_MINUS_1: "-1d",
  DAY_7: "7d",
};

export const customRanges = [
  { label: "Past 1 Hour", value: RANGE_TYPE_LABELS.HOUR_1, noOfDays: 1 },
  { label: "Past 2 Hours", value: RANGE_TYPE_LABELS.HOUR_2, noOfDays: 1 },
  { label: "Past 12 Hours", value: RANGE_TYPE_LABELS.HOUR_12, noOfDays: 1 },
  { label: "Last 24 Hours", value: RANGE_TYPE_LABELS.HOUR_24, noOfDays: 1 },
  { label: "Today", value: RANGE_TYPE_LABELS.DAY_1, noOfDays: 1 },
  { label: "Yesterday", value: RANGE_TYPE_LABELS.DAY_MINUS_1, noOfDays: 1 },
  { label: "Past 7 Days", value: RANGE_TYPE_LABELS.DAY_7, noOfDays: 7 },
  { label: "Custom", value: RANGE_TYPE_LABELS.CUSTOM, noOfDays: -1 },
];

export const DEFAULT_TIME_RANGE = RANGE_TYPE_LABELS.HOUR_12;

export const TEXT_LIBRARY = {
  NO_DATA_AVAILABLE: "No data available",
  START_TIME: "Start Time",
  END_TIME: "End Time",
  INVALID_CREDENTIALS: "Invalid email or password. Please try again.",
  NO_ACTIVE_SITEID_FOUND: "No active site ID was found for this charger.",
  ERROR_IN_FETCHING_SITEID: "Error in fetching siteId",
  SERVER_ERROR: "Server error. Please try again",
};

export const SNACKBAR_CONSTANTS = {
  HIDE_DURATION: 5000,
};
